/* Atelier Bloom – theme scripts (no dependencies) */
(function () {
  'use strict';

  const theme = window.theme || { routes: {}, strings: {} };
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const fetchJSON = (url, options = {}) =>
    fetch(url, {
      ...options,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...(options.headers || {}) }
    }).then(async (res) => {
      const data = await res.json();
      if (!res.ok || data.status) throw data;
      return data;
    });

  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ---------------- Toast ---------------- */
  let toastTimer;
  function toast(message) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------------- Announcement rotator ---------------- */
  function initRotators() {
    $$('[data-rotator]').forEach((track) => {
      const items = $$('.announcement__item', track);
      if (items.length < 2) return;
      let index = 0;
      const interval = parseInt(track.dataset.interval, 10) || 4000;
      setInterval(() => {
        const current = items[index];
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        setTimeout(() => current.classList.remove('is-leaving'), 600);
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, interval);
    });
  }

  /* ---------------- Header ---------------- */
  function initHeader() {
    const header = $('[data-header]');
    if (header) {
      const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Drawers built on <details>
    $$('details[data-drawer]').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.classList.contains('mobile-menu')) document.body.classList.toggle('overflow-hidden', details.open);
        if (details.open) {
          const input = $('input[type="search"]', details);
          if (input) setTimeout(() => input.focus(), 50);
        }
      });
      $$('[data-drawer-close]', details).forEach((btn) =>
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          details.open = false;
        })
      );
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      $$('details[data-drawer][open], details[data-facet][open]').forEach((d) => (d.open = false));
      closeCart();
    });

    // Close facet panels when clicking outside
    document.addEventListener('click', (e) => {
      $$('details[data-facet][open]').forEach((d) => {
        if (!d.contains(e.target)) d.open = false;
      });
    });
  }

  /* ---------------- Slideshow ---------------- */
  function initSlideshows(ctx = document) {
    $$('[data-slideshow]', ctx).forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const slides = $$('.slide', root);
      const dots = $$('[data-dot]', root);
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const go = (i) => {
        slides[index].classList.remove('is-active');
        dots[index] && dots[index].classList.remove('is-active');
        index = (i + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        dots[index] && dots[index].classList.add('is-active');
      };
      const play = () => {
        if (root.dataset.autoplay !== 'true') return;
        clearInterval(timer);
        timer = setInterval(() => go(index + 1), parseInt(root.dataset.interval, 10) || 6000);
      };
      $('[data-next]', root)?.addEventListener('click', () => { go(index + 1); play(); });
      $('[data-prev]', root)?.addEventListener('click', () => { go(index - 1); play(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { go(parseInt(dot.dataset.dot, 10)); play(); }));
      root.addEventListener('mouseenter', () => clearInterval(timer));
      root.addEventListener('mouseleave', play);

      // Touch swipe
      let startX = null;
      root.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
      root.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) { go(index + (dx < 0 ? 1 : -1)); play(); }
        startX = null;
      });

      // Theme editor: show the selected slide
      document.addEventListener('shopify:block:select', (e) => {
        const i = slides.indexOf(e.target);
        if (i > -1) { clearInterval(timer); go(i); }
      });
      play();
    });
  }

  /* ---------------- Horizontal scrollers ---------------- */
  function initScrollers(ctx = document) {
    $$('[data-scroller]', ctx).forEach((root) => {
      const list = $('ul', root);
      if (!list) return;
      const step = () => (list.firstElementChild ? list.firstElementChild.getBoundingClientRect().width + 20 : 300);
      $('[data-scroll-next]', root)?.addEventListener('click', () => list.scrollBy({ left: step(), behavior: 'smooth' }));
      $('[data-scroll-prev]', root)?.addEventListener('click', () => list.scrollBy({ left: -step(), behavior: 'smooth' }));
    });
  }

  /* ---------------- Quantity inputs ---------------- */
  function initQuantity(ctx = document) {
    $$('[data-qty]', ctx).forEach((wrap) => {
      const input = $('input', wrap);
      $('[data-qty-minus]', wrap)?.addEventListener('click', () => {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      $('[data-qty-plus]', wrap)?.addEventListener('click', () => {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* ---------------- Cart ---------------- */
  const cartDrawer = () => $('[data-cart-drawer]');
  let lastFocus = null;

  function openCart() {
    const drawer = cartDrawer();
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    setTimeout(() => $('.cart-drawer__panel', drawer)?.focus(), 50);
  }

  function closeCart() {
    const drawer = cartDrawer();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    lastFocus && lastFocus.focus && lastFocus.focus();
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  }

  function renderDrawer(html) {
    const drawer = cartDrawer();
    if (!drawer || !html) return;
    const fresh = $('[data-cart-drawer-inner]', parseHTML(html));
    const current = $('[data-cart-drawer-inner]', drawer);
    if (fresh && current) current.replaceWith(fresh);
  }

  function refreshDrawer() {
    return fetch(`${theme.routes.root}?sections=cart-drawer`)
      .then((r) => r.json())
      .then((sections) => renderDrawer(sections['cart-drawer']));
  }

  function changeLine(line, quantity) {
    const drawer = cartDrawer();
    const inner = drawer && $('[data-cart-drawer-inner]', drawer);
    inner && inner.classList.add('is-loading');
    return fetchJSON(`${theme.routes.cartChange}.js`, {
      method: 'POST',
      body: JSON.stringify({ line, quantity, sections: ['cart-drawer'] })
    })
      .then((cart) => {
        updateCount(cart.item_count);
        if ($('[data-cart-page]')) return window.location.reload();
        renderDrawer(cart.sections && cart.sections['cart-drawer']);
      })
      .catch((err) => {
        inner && inner.classList.remove('is-loading');
        toast((err && (err.description || err.message)) || theme.strings.error);
      });
  }

  function initCart() {
    // Open drawer from header icon
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-cart-toggle]');
      if (toggle && theme.cartType === 'drawer' && cartDrawer() && !$('[data-cart-page]')) {
        e.preventDefault();
        openCart();
        return;
      }
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        closeCart();
        return;
      }
      const changeBtn = e.target.closest('[data-line-change]');
      if (changeBtn) {
        e.preventDefault();
        const lineEl = changeBtn.closest('[data-line]');
        changeLine(parseInt(lineEl.dataset.line, 10), parseInt(changeBtn.dataset.lineChange, 10));
      }
    });

    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-line-input]');
      if (!input) return;
      const lineEl = input.closest('[data-line]');
      changeLine(parseInt(lineEl.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    });

    // Product forms (product page + quick add)
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();
      const button = $('[type="submit"][name="add"], [data-add-button]', form);
      const errorEl = $('[data-form-error]', form);
      if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
      if (errorEl) errorEl.hidden = true;

      const formData = new FormData(form);
      if (theme.cartType === 'drawer' && cartDrawer()) formData.append('sections', 'cart-drawer');

      fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(async (res) => {
          const data = await res.json();
          if (!res.ok || data.status) throw data;
          return data;
        })
        .then((data) => {
          if (theme.cartType !== 'drawer' || !cartDrawer()) {
            window.location.href = theme.routes.cart;
            return;
          }
          if (data.sections && data.sections['cart-drawer']) renderDrawer(data.sections['cart-drawer']);
          else return refreshDrawer();
        })
        .then(() => fetchJSON(`${theme.routes.cart}.js`))
        .then((cart) => {
          if (!cart) return;
          updateCount(cart.item_count);
          openCart();
        })
        .catch((err) => {
          const msg = (err && (err.description || err.message)) || theme.strings.error;
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else toast(msg);
        })
        .finally(() => {
          if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
        });
    });
  }

  /* ---------------- Product page ---------------- */
  function initProduct(ctx = document) {
    $$('[data-product-section]', ctx).forEach((section) => {
      const picker = $('[data-variant-picker]', section);
      const gallery = $('.gallery', section);
      const counter = $('[data-gallery-current]', section);

      // Gallery counter (mobile slider)
      if (gallery && counter) {
        gallery.addEventListener('scroll', () => {
          const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
          counter.textContent = i + 1;
        }, { passive: true });
      }

      if (!picker) return;
      const variantsEl = $('[data-variants]', picker);
      const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      const sectionId = section.dataset.sectionId;
      const productUrl = section.dataset.productUrl;

      picker.addEventListener('change', (e) => {
        const fieldset = e.target.closest('fieldset');
        if (fieldset) {
          const label = $('[data-selected-label]', fieldset);
          if (label) label.textContent = e.target.value;
        }
        const selected = $$('fieldset', picker).map((fs) => {
          const checked = $('input:checked', fs);
          return checked ? checked.value : null;
        });
        const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        const idInput = $('[data-variant-id]', section);
        const button = $('[data-add-button]', section);
        const label = $('[data-add-label]', section);

        if (!variant) {
          if (button) button.disabled = true;
          if (label) label.textContent = theme.strings.unavailable;
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (button) button.disabled = !variant.available;
        if (label) label.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        // Scroll gallery to the variant image
        if (variant.featured_media && gallery) {
          const target = $(`[data-media-id="${variant.featured_media.id}"]`, gallery);
          if (target) {
            $$('.gallery__item', gallery).forEach((el) => el.classList.toggle('is-active', el === target));
            if (window.matchMedia('(min-width: 990px)').matches) {
              if (target !== gallery.firstElementChild) gallery.prepend(target);
            } else {
              gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
            }
          }
        }

        // Re-render price and option availability from the server
        fetch(`${productUrl}?variant=${variant.id}&section_id=${sectionId}`)
          .then((r) => r.text())
          .then((html) => {
            const doc = parseHTML(html);
            const freshPrice = $('[data-price]', doc);
            const price = $('[data-price]', section);
            if (freshPrice && price) price.innerHTML = freshPrice.innerHTML;
            const freshPills = $$('[data-variant-picker] .pill', doc);
            $$('.pill', picker).forEach((pill, i) => {
              if (freshPills[i]) pill.classList.toggle('is-unavailable', freshPills[i].classList.contains('is-unavailable'));
            });
          })
          .catch(() => {});
      });
    });

    // Modals (size chart)
    $$('[data-modal-open]', ctx).forEach((btn) => {
      btn.addEventListener('click', () => {
        const dialog = document.getElementById(btn.dataset.modalOpen);
        if (dialog && dialog.showModal) dialog.showModal();
      });
    });
    $$('dialog.modal', ctx).forEach((dialog) => {
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog || e.target.closest('[data-modal-close]')) dialog.close();
      });
    });
  }

  /* ---------------- Product recommendations ---------------- */
  function initRecommendations(ctx = document) {
    $$('[data-recommendations]', ctx).forEach((el) => {
      if (el.dataset.loaded) return;
      const load = () => {
        el.dataset.loaded = '1';
        fetch(el.dataset.url)
          .then((r) => r.text())
          .then((html) => {
            const fresh = $('[data-recommendations]', parseHTML(html));
            if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
          })
          .catch(() => {});
      };
      if (!('IntersectionObserver' in window)) return load();
      const io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    });
  }

  /* ---------------- Collection facets ---------------- */
  function initFacets() {
    $$('form[data-facets]').forEach((form) => {
      form.addEventListener('change', (e) => {
        if (e.target.matches('input[type="checkbox"], [data-autosubmit]')) {
          const params = new URLSearchParams(new FormData(form));
          // drop empty price inputs
          for (const [key, value] of Array.from(params.entries())) if (value === '') params.delete(key);
          window.location.search = params.toString();
        }
      });
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const params = new URLSearchParams(new FormData(form));
        for (const [key, value] of Array.from(params.entries())) if (value === '') params.delete(key);
        window.location.search = params.toString();
      });
    });
  }

  /* ---------------- Scroll reveal ---------------- */
  function initReveal() {
    if (window.Shopify && window.Shopify.designMode) {
      document.body.classList.add('design-mode');
      return;
    }
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = $$('.main .shopify-section').slice(1).map((s) => s.firstElementChild).filter(Boolean);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach((t) => {
      if (t.getBoundingClientRect().top < window.innerHeight) return;
      t.setAttribute('data-reveal', '');
      io.observe(t);
    });
  }

  /* ---------------- Theme editor support ---------------- */
  document.addEventListener('shopify:section:load', (e) => {
    initSlideshows(e.target);
    initScrollers(e.target);
    initQuantity(e.target);
    initProduct(e.target);
    initRecommendations(e.target);
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('[data-cart-drawer]')) openCart();
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.querySelector('[data-cart-drawer]')) closeCart();
  });

  /* ---------------- Boot ---------------- */
  document.addEventListener('DOMContentLoaded', () => {
    initRotators();
    initHeader();
    initSlideshows();
    initScrollers();
    initQuantity();
    initCart();
    initProduct();
    initRecommendations();
    initFacets();
    initReveal();
  });

  window.theme = Object.assign(theme, { openCart, closeCart, refreshDrawer, toast });
})();
